import { type RefObject, createContext, useContext } from 'react';
import { type PopupProps } from './types';
export type PopupContext = {
  initialised: boolean;
  open: boolean;
  inDOM: boolean;
  setInDOM: (inDOM: boolean) => void;
  showPopup: () => void;
  hidePopup: () => void;
  togglePopup: () => void;
  spyRef?: Readonly<RefObject<HTMLDivElement | null>>;
  popupRef?: Readonly<RefObject<HTMLDivElement | null>>;
  hasHoverTrigger: boolean;
  hasKeypressTrigger: boolean;
  hasClickTrigger: boolean;
  hasFocusTrigger: boolean;
  parentContext?: PopupContext;
} & Pick<PopupProps, 'alignPopup' | 'preferredPopupPosition' | 'Anchor' | 'contentClassName' | 'contentWrapperClassName' | 'popupOpenWrapperClassName' | 'anchorClassName' | 'marginInPx'>;
export const PopupContext = createContext<PopupContext>({
  initialised: false,
  open: false,
  inDOM: false,
  setInDOM: () => {},
  showPopup: () => {},
  hidePopup: () => {},
  togglePopup: () => {},
  hasClickTrigger: false,
  hasKeypressTrigger: false,
  hasFocusTrigger: false,
  hasHoverTrigger: false
});
export function usePopupContext() {
  return useContext(PopupContext);
}